<template>
  <div>
    <b-col>
      <div class="row">
        <div class="col-sm-8">&nbsp;</div>
        <div class="col-sm-4 text-right">
          <b-dropdown
            text="Nueva orden de servicio"
            size="sm"
            class="btn b-dropdown text-right"
            variant="success"
            :disabled="isCustomer"
          >
            <b-dropdown-item @click="add()" :disabled="!CREATE">Cartera</b-dropdown-item>
            <!-- <b-dropdown-item>Libranzas</b-dropdown-item>
            <b-dropdown-item>Estudio de crédito</b-dropdown-item>
            <b-dropdown-item>Constitución de titulo valor</b-dropdown-item>

            <b-dropdown-item>
              <span class="text-danger">Proceso de restitución de inmueble arrendado</span>
            </b-dropdown-item>
            <b-dropdown-item>
              <span class="text-danger">Insolvencia empresarial</span>
            </b-dropdown-item>
            <b-dropdown-item>
              <span class="text-danger">Certificación de castigo de cartera</span>
            </b-dropdown-item>-->
          </b-dropdown>
        </div>
      </div>
    </b-col>

    <section class="proj-page-section comments">
      <section class="without" v-if="!lstServiceOrders.length > 0" style="margin-top:0px">
        <div class="row">
          <figure class="text-center">
            <img src="img/sin_datos.png" alt width="150px" />
          </figure>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
            <h1>Oops!</h1>
            <h4>
              No hay ordenes de servicio
              <br />en esta cuenta.
            </h4>
          </div>
        </div>
      </section>

      <section v-else class="mt-2">
        <b-table
          :hover="true"
          :striped="true"
          :bordered="false"
          :small="false"
          :fixed="false"
          responsive="sm"
          :items="lstServiceOrders"
          :fields="fields"
        >
          <!-- <template slot="HEAD_selected" >
                  <input type="checkbox" @click.stop v-model="selectAllTask" @change="toggleSelectAllTask" />
              </template>

              <template slot="selected" slot-scope="data">
                <input type="checkbox" v-model="data.item.selected" @change="selectRowTask(data.item)" />
          </template>-->

          <template slot="status" slot-scope="data">
            <b-badge :variant="getBadge(data.item.status)">{{getTextStatus(data.item.status)}}</b-badge>
          </template>

          <template slot="date" slot-scope="data">{{formatDate(data.item.date)}}</template>

          <template slot="actions" slot-scope="data">
          <!-- <template v-slot:cell(actions)="data"> -->
            <b-button size="sm" variant="primary" class="mr-1" title="ver" 
            @click="view(data.item)"
            :disabled="!READ"
            >
              <i class="fa fa-eye"></i>
            </b-button>

            <b-button
              size="sm"
              variant="success"
              class="mr-1"
              title="Editar"
              @click="edit(data.item)"
              :disabled="isCustomer ? true : !UPDATE"
            >
              <i class="fa fa-edit"></i>
            </b-button>

            <b-button
              size="sm"
              variant="danger"
              @click="deleteItem(data.item)"
              title="Eliminar"
              :disabled="isCustomer ? true : !DELETE"
            >
              <i class="fa fa-trash"></i>
            </b-button>
          </template>
        </b-table>
      </section>
    </section>

    <!-- MODAL PARA LOS CONRATOS -->
    <div class="modal fade" id="dlgOrdenServicio">
      <div class="modal-dialog modal-dialog-centered modal-success modal-lg">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">ORDEN DE SERVICIO</h4>
            <button type="button" class="close" @click="close">&times;</button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <form @submit.prevent="save()" method="post" v-if="serviceOrder.customer_id">
              <b-row>
                <b-col cols="11" sm="11" class="center-block">
                  <b-row>
                    <b-col sm="12" v-if="errores.length">
                      <b-alert show variant="danger">
                        <b>Por favor corrige los siguientes errores:</b>
                        <ul>
                          <li v-for="(error, index) in errores" :key="index">{{ error }}</li>
                        </ul>
                      </b-alert>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="4">
                      <b-form-group>
                        <label for="txtNumero">Número de orden</label>
                        <b-form-input
                          type="text"
                          id="txtNumero"
                          v-model="serviceOrder.number"
                          :disabled="true"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>

                    <b-col sm="4">
                      <b-form-group>
                        <label for="txtFecha">Fecha</label>
                        <b-form-input
                          type="date"
                          id="txtFecha"
                          v-model="serviceOrder.date"
                          :disabled="disabledForm"
                          :max="maxDate"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>

                    <b-col sm="4">
                      <b-form-group>
                        <label for="cmbEstado">Estado</label>
                        <b-form-select
                          v-model="serviceOrder.status"
                          id="cmbEstado"
                          :disabled="disabledForm || !isAdmin"
                        >
                          <template slot="first">
                            <option :value="null" disabled>-- Seleccione --</option>
                          </template>
                          <option value="P">Por activar</option>
                          <option value="A">Activo</option>
                          <option value="E">En gestión</option>
                          <option value="F">Completada</option>
                          <option value="C">Cancelada</option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="4">
                      <b-form-group>
                        <label for="cmbTipo">Contrato</label>
                        <b-form-select
                          v-model="serviceOrder.agreement_id"
                          id="cmbTipo"
                          :disabled="disabledForm"
                          @change="getAgreement()"
                        >
                          <template slot="first">
                            <option :value="null" disabled>-- Seleccione --</option>
                          </template>
                          <option
                            v-for="item in lstAgreements"
                            :key="item.id"
                            :value="item.id"
                          >{{ item.number }}</option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>

                    <b-col sm="4">
                      <b-form-group>
                        <label for="txtPorcentajeAcuerdoPrejuridico">Acuerdo prejurídico</label>
                        <b-input-group>
                          <b-form-input
                            type="text"
                            id="txtPorcentajeAcuerdoPrejuridico"
                            v-model="serviceOrder.prejury_percentage"
                            :disabled="disabledForm"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-input-group-text>
                              <i class="fa fa-percent"></i>
                            </b-input-group-text>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col sm="4">
                      <b-form-group>
                        <label for="txtPorcentajeAcuerdojuridico">Acuerdo jurídico</label>
                        <b-input-group>
                          <b-form-input
                            type="text"
                            id="txtPorcentajeAcuerdoPrejuridico"
                            v-model="serviceOrder.legal_percentage"
                            :disabled="disabledForm"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-input-group-text>
                              <i class="fa fa-percent"></i>
                            </b-input-group-text>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="4">
                      <b-form-group>
                        <label for="cmbTipo">Tipo de cartera</label>
                        <b-form-select
                          v-model="serviceOrder.wallet_type_id"
                          id="cmbTipo"
                          :disabled="disabledForm"
                        >
                          <template slot="first">
                            <option :value="null" disabled>-- Seleccione --</option>
                          </template>
                          <option
                            v-for="item in lstWalletType"
                            :key="item.id"
                            :value="item.id"
                          >{{ item.name }}</option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>

                    <!-- <b-col sm="4">
                      <b-form-group>
                        <label for="cmbEstado">¿Permite montos minimos?</label>
                        <b-form-select
                          v-model="serviceOrder.smaller_amount"
                          id="cmbEstado"
                          :disabled="disabledForm"
                        >
                          <template slot="first">
                            <option :value="null" disabled>-- Seleccione --</option>
                          </template>
                          <option value="S">Si</option>
                          <option value="N">No</option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>

                    <b-col sm="4">
                      <b-form-group>
                        <label for="cmbPrescrita">¿Permite cartera prescrita?</label>
                        <b-form-select
                          v-model="serviceOrder.pre_written"
                          id="cmbPrescrita"
                          :disabled="disabledForm"
                        >
                          <template slot="first">
                            <option :value="null" disabled>-- Seleccione --</option>
                          </template>
                          <option value="S">Si</option>
                          <option value="N">No</option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>-->
                    <!-- </b-row>

                    <b-row>-->
                    <b-col sm="4">
                      <b-form-group>
                        <label for="cmbFee">¿Permite cobro de honorarios?</label>
                        <b-form-select
                          v-model="serviceOrder.fee"
                          id="cmbFee"
                          :disabled="disabledForm"
                        >
                          <template slot="first">
                            <option :value="null" disabled>-- Seleccione --</option>
                          </template>
                          <option value="S">Si</option>
                          <option value="N">No</option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>

                    <b-col sm="4">
                      <b-form-group>
                        <label for="cmbComercial">Comercial</label>
                        <b-form-select
                          id="cmbComercial"
                          v-model="serviceOrder.staff_id"
                          :disabled="disabledForm"
                        >
                          <template slot="first">
                            <option :value="null" disabled>-- Selecione --</option>
                          </template>
                          <option
                            v-for="item in lstStaffs"
                            :key="item.id"
                            :value="item.id"
                          >{{ item.name }} {{ item.last_name }} - {{ item.type_name }}</option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row v-if="disabledForm == false">
                    <b-col sm="12">
                      <label>Adjuntar archivo</label>
                      <b-form-file
                        :browse-text="'Buscar'"
                        v-model="file"
                        :state="Boolean(file)"
                        v-on:change="onImageChange"
                        placeholder="Elija un archivo o suéltelo aquí ..."
                        drop-placeholder="Suelta el archivo aquí ..."
                      ></b-form-file>

                      <!-- <uploadFile :uri="this.$urlApi" :tok="this.token" :table="this.table" :id="this.$route.params.id"></uploadFile> -->
                    </b-col>
                  </b-row>

                  <b-row class="mt-2">
                    <b-col sm="12">
                      <b-form-group>
                        <label for="txtComentario">Comentario</label>
                        <b-form-textarea
                          rows="4"
                          id="txtComentario"
                          no-resize
                          v-model="serviceOrder.description"
                          :disabled="disabledForm"
                        ></b-form-textarea>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row v-if="!disabledForm">
                    <b-col sm="4" class="center-block">
                      <b-button
                        type="submit"
                        variant="success"
                        class="btn-sm col-sm-12"
                        :disabled="disabledForm"
                      >Guardar</b-button>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- FIN MODAL PARA LOS CONRATOS -->
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "agreement",
  props: ["_customer_id"],
  data: () => {
    return {
      token: localStorage.getItem("token"),
      isAdmin: localStorage.getItem("auth_is_admin") === "S" ? true : false,
      maxDate: moment(String(new Date())).format("YYYY-MM-DD"),
      isCustomer: false,
      // CABECERAS PARA LA TABLA DE LOS AGREEMENTS
      fields: [
        {
          key: "selected",
          sortable: false,
          label: "",
          class: "options-column"
        },
        { key: "number", label: "Número" },
        { key: "status", label: "Estado" },
        { key: "wallet_type_name", label: "Tipo" },
        { key: "date", label: "Fecha" },
        { key: "staff_name", label: "Comercial" },
        { key: "actions", label: "Opciones" }
      ],
      lstWalletType: [],
      lstServiceOrders: [],
      lstAgreements: [],
      isEdit: false,
      disabled: false,
      datos: [],
      errores: [],
      table: "customers",
      lstStaffs: [],
      isedit: false,
      disabledForm: false,
      customer_id: null,

      serviceOrder: {
        number: null,
        date: null,
        customer_id: null,
        staff_id: null,
        prejury_percentage: null,
        legal_percentage: null,
        agreement_id: null,
        smaller_amount: null,
        pre_written: null,
        wallet_type_id: null,
        status: null,
        description: null,
        fee: null
      },
      file: null,
      // ------------------------------------------------------------------------
      // VARIABLES PARA LA GESTÓN DE LAS ACCIONES Y PERMISOS DE CADA USUARIO
      // ------------------------------------------------------------------------
      CREATE: false,
      READ: false,
      UPDATE: false,
      DELETE: false,
    };
  },
  created() {
    this.enabledActions();
    var auth = localStorage.getItem("auth");
    auth = JSON.parse(auth);
    this.isCustomer = auth[0].customer_id != null ? true : false;

    this.customer_id =
      this._customer_id === undefined ? null : this._customer_id;
    this.getServiceOrders();
  },

  methods: {
    enabledActions() {
      var auth = localStorage.getItem("auth");
      auth = JSON.parse(auth)[0];
      this.CREATE = auth.create == 1;
      this.READ   = auth.read == 1;
      this.UPDATE = auth.update == 1;
      this.DELETE = auth.delete == 1;
    },
    getServiceOrders() {
      showLoader();
      let id = this.$route.params.id;
      // CARGAR EL LISTADO ORDENES DE SERVICIO
      this.$http
        .get(
          `${this.$urlApi}serviceorders/customer/${this.customer_id}?token=${this.token}`
        )
        .then(
          response => {
            this.lstServiceOrders = response.data.data;
          },
          error => {
            console.log(error);
            this.errores = getMsgError(error);
          }
        );
      hideLoader();
    },
    getRowCount(items) {
      return items.length;
    },
    getBadge(status) {
      return getBadge(status);
    },
    getTextStatus(status) {
      return status === "A"
        ? "Activo"
        : status === "C"
        ? "Cancelada"
        : status === "P"
        ? "Por activar"
        : status === "E"
        ? "En gestión"
        : status === "F"
        ? "Completada"
        : "";
    },
    formatDate(value) {
      return moment(String(value)).format("DD/MM/YYYY");
    },
    getAgreement() {
      showLoader();
      this.serviceOrder.prejury_percentage = null;
      this.serviceOrder.legal_percentage = null;
      this.$http
        .get(
          `${this.$urlApi}agreements/${this.serviceOrder.agreement_id}?token=${this.token}`
        )
        .then(
          response => {
            //console.log(response)
            this.serviceOrder.prejury_percentage =
              response.data.data.prejury_percentage;
            this.serviceOrder.legal_percentage =
              response.data.data.legal_percentage;
            hideLoader();
          },
          error => {
            console.log(error);
            hideLoader();
          }
        );
    },
    initParameters() {
      // 11: TIPO DE CARTERA
      this.$http.get(`${this.$urlApi}parameters/11?token=${this.token}`).then(
        response => {
          this.lstWalletType = response.data.data;
        },
        error => {
          console.log(error);
        }
      );

      // CARGAR EL LISTADO DE ACUERDOS
      var status = "%%";
      this.$http
        .get(
          `${this.$urlApi}agreements/customer/${this.customer_id}/status/${status}?token=${this.token}`
          // `${this.$urlApi}agreements/customer/${this.customer_id}?token=${this.token}`
        )
        .then(
          response => {
            this.lstAgreements = response.data.data;
          },
          error => {
            console.log(error);
            this.errores = getMsgError(error);
          }
        );

      /*
      this.$http.get(`${this.$urlApi}staffs?token=${this.token}`).then(response => {
        this.lstStaffs = response.data.data        
      }, error => {console.log(error)})
    */

      this.$http
        .get(
          `${this.$urlApi}staffs/custumer/${this.customer_id}?token=${this.token}`
        )
        .then(
          response => {
            this.lstStaffs = response.data.data;
          },
          error => {
            console.log(error);
          }
        );
    },
    add() {
      this.initParameters();
      this.errores = [];
      $("#dlgOrdenServicio").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.isedit = false;
      this.file = null;
      // INICIALIZAR LOS CAMPOR DEL ACUERDO
      this.serviceOrder.number = null;
      this.serviceOrder.name = null;
      this.serviceOrder.date = null;
      this.serviceOrder.customer_id = this.customer_id;
      this.serviceOrder.staff_id = null;
      this.serviceOrder.prejury_percentage = null;
      this.serviceOrder.legal_percentage = null;

      this.serviceOrder.agreement_id = null;
      this.serviceOrder.smaller_amount = null;
      this.serviceOrder.pre_written = null;
      this.serviceOrder.fee = null;

      (this.serviceOrder.wallet_type_id = null),
        (this.serviceOrder.status = "P");
      this.serviceOrder.description = null;

      $("#dlgOrdenServicio").modal("show");
    },
    edit(item) {
      if (!this.isAdmin && item.status === "A") {
        this.$swal({
          title: "Advertencia",
          text:
            "La orden de servicio no se puede editar, ya se encuenta activada!",
          type: "warning",
          showCancelButton: false,
          confirmButtonText: "Aceptar"
        });
        return false;
      }

      this.initParameters();
      this.errores = [];
      $("#dlgOrdenServicio").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.serviceOrder = item;
      this.file = null;
      //console.log(item)
      this.isedit = true;
      $("#dlgOrdenServicio").modal("show");
    },
    view(item) {
      showLoader();
      this.initParameters();
      $("#dlgOrdenServicio").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.serviceOrder = item;
      this.disabledForm = true;
      hideLoader();
      $("#dlgOrdenServicio").modal("show");
    },
    save() {
      if (this.isedit) {
        this.update();
      } else {
        this.$swal({
          title: "Guardar",
          text: "¿Está seguro que toda la información ingresada es correcta?",
          type: "question",
          showCancelButton: true,
          cancelButtonText: "Volver",
          confirmButtonText: "Si"
        }).then(result => {
          if (result.value) {
            this.create();
          }
        });
      }
    },
    create() {
      showLoader();

      let auth = localStorage.getItem("auth");
      auth = JSON.parse(auth);
      this.serviceOrder.url = `${location.origin}/#/customers/view/`;
      this.serviceOrder.user_id = auth[0].id;
      this.serviceOrder.auth_is_admin = this.isAdmin;

      this.datos = JSON.stringify(this.serviceOrder);
      let formData = new FormData();
      formData.append("data", JSON.stringify(this.serviceOrder));
      formData.append("document", this.file);

      //console.log(this.datos)
      //return false

      this.$http
        .post(`${this.$urlApi}serviceorders?token=${this.token}`, formData, {
          headers: { "Content-Type": undefined }
        })
        .then(function(response) {
          console.log(response);

          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Arden de servicios guardada correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar"
          }).then(result => {
            if (result.value) {
              // CERRAR EL MODAL Y LISTAR EL CONTRATO GUARDADO
              this.serviceOrder.customer_id = null;
              this.lstStaffs = [];
              this.getServiceOrders();
              $("#dlgOrdenServicio").modal("hide");
            }
          });
        })
        .catch(error => {
          console.log(error);
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    update() {
      showLoader();

      let auth = localStorage.getItem("auth");
      auth = JSON.parse(auth);
      this.serviceOrder.url = `${location.origin}/#/customers/view/`;
      this.serviceOrder.user_id = auth[0].id;
      this.serviceOrder.auth_is_admin = this.isAdmin;

      this.datos = JSON.stringify(this.serviceOrder);
      let formData = new FormData();
      formData.append("data", JSON.stringify(this.serviceOrder));
      formData.append("document", this.file);
      formData.append("_method", "PUT");
      // COMO ES UN OBJETO FormData SE DEBE ENVIAR UN POST Y CAMBIAR EL METODO A PUT, SOLO SIRVE PARA LARAVEL
      this.$http
        .post(
          `${this.$urlApi}serviceorders/${this.serviceOrder.id}?token=${this.token}`,
          formData,
          { headers: { "Content-Type": undefined } }
        )
        .then(function(response) {
          console.log(response);
          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Arden de servicios actualizada correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar"
          }).then(result => {
            if (result.value) {
              // CERRAR EL MODAL Y LISTAR EL CONTRATO GUARDADO
              this.serviceOrder.customer_id = null;
              this.lstStaffs = [];
              this.getServiceOrders();
              $("#dlgOrdenServicio").modal("hide");
            }
          });
        })
        .catch(error => {
          console.log(error);
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    deleteItem(item) {
      if (!this.isAdmin && item.status === "A") {
        this.$swal({
          title: "Advertencia",
          text:
            "La orden de servicio no se puede eliminar, ya se encuenta activada!",
          type: "warning",
          showCancelButton: false,
          confirmButtonText: "Aceptar"
        });
        return false;
      }

      this.$swal({
        title: "Eliminar",
        text: "Desea eliminar la orden de servicio ?",
        type: "question",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Aceptar"
      }).then(result => {
        if (result.value) {
          showLoader();
          this.$http
            .delete(
              `${this.$urlApi}serviceorders/${item.id}?token=${this.token}`,
              { headers: { "Content-Type": "application/json" } }
            )
            .then(function(response) {
              console.log(response);
              hideLoader();

              this.$swal({
                title: "Buen trabajo",
                text: "orden de servicio eliminada correctamente!",
                type: "success",
                showCancelButton: false,
                confirmButtonText: "Aceptar"
              }).then(result => {
                if (result.value) {
                  this.getServiceOrders();
                }
              });
            })
            .catch(error => {
              console.log(error.body.error);
              hideLoader();
            });
        }
      });
    },
    close() {
      /*this.serviceOrder.number = null
      this.serviceOrder.name = null
      this.serviceOrder.date = null
      this.serviceOrder.customer_id = null
      this.serviceOrder.staff_id=null      
      this.serviceOrder.prejury_percentage = null
      this.serviceOrder.legal_percentage = null
      this.serviceOrder.percentage_lower = null
      this.serviceOrder.percentage_between = null
      this.serviceOrder.percentage_higher = null            
      this.serviceOrder.recurrent = null
      this.serviceOrder.status = null
      this.serviceOrder.description = null
      this.serviceOrder.process_id= null */

      this.isedit = false;
      this.disabledForm = false;
      $("#dlgOrdenServicio").modal("hide");
    },
    onImageChange(e) {
      console.log(e.target.files[0]);
      this.file = e.target.files[0];
    }
  }
};
</script>
